/* global angular */

angular.module('AemTransparentAccount')
  .factory('searchDataservice', searchDataservice)

searchDataservice.$inject = ['textToolsService']

function searchDataservice (textToolsService) {
  var _allAccounts = []
  var _accountsLookup = {}
  var _WILDCARD_LETTER = '§'

  function init (allAccounts) {
    _allAccounts = allAccounts.sort(function (a, b) {
      var aName = a.name ? a.name.trim() : ''
      var bName = b.name ? b.name.trim() : ''
      return aName.localeCompare(bName)
    })
    _accountsLookup = createAccountsLookupByNameFirstLetter(_allAccounts)
  }

  function createAccountsLookupByNameFirstLetter (allAccounts) {
    var accountsLookup = {}
    for (var i = 0, len = allAccounts.length; i < len; i++) {
      try {
        var name = allAccounts[i].name.trim()
        var upperFirstChar = name[0].toUpperCase()
        var upperSecondChar = name[1].toUpperCase()
        var lookupIndex = textToolsService.removeDiacritics(upperFirstChar)
        // Ch
        if (upperFirstChar === 'C' && upperSecondChar === 'H') {
          lookupIndex = 'Ch'
        }
        // nonletters
        if (!lookupIndex.match(/[A-Z]/i)) {
          lookupIndex = _WILDCARD_LETTER
        }
      } catch (e) {
        lookupIndex = _WILDCARD_LETTER
      }
      if (!accountsLookup[lookupIndex]) {
        accountsLookup[lookupIndex] = []
      }
      accountsLookup[lookupIndex].push(allAccounts[i])
    }
    return accountsLookup
  }

  function getFirstLetterFrequency () {
    var allLetters = [_WILDCARD_LETTER, 'A', 'B', 'C', 'D', 'F', 'E', 'G', 'H', 'Ch', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
    return allLetters.map(function (letter) {
      return {
        letter: letter,
        count: _accountsLookup[letter] ? _accountsLookup[letter].length : 0
      }
    })
  }

  function getAccountsByNameFirstLetter (letter) {
    return _accountsLookup[letter] || []
  }

  function getAccountsByKeyword (keyword) {
    return _allAccounts.filter(function (account) {
      return (account.name && ~indexOfWithoutDiacriticsCaseInsensitive(account.name, keyword)) ||
        (account.accountNumber && ~account.accountNumber.indexOf(keyword))
    })
  }

  function getAllAccounts () {
    return _allAccounts
  }

  function indexOfWithoutDiacriticsCaseInsensitive (string, substring) {
    return textToolsService.removeDiacritics(string.toLowerCase()).indexOf(textToolsService.removeDiacritics(substring.toLowerCase()))
  }

  return {
    init: init,
    getFirstLetterFrequency: getFirstLetterFrequency,
    getAccountsByNameFirstLetter: getAccountsByNameFirstLetter,
    getAccountsByKeyword: getAccountsByKeyword,
    getAllAccounts: getAllAccounts
  }
}
